export default __webpack_public_path__ + "static/media/feedback_try_01.492f38e9.png";